import FieldSet from '../../FieldSet';

import { WatchersCount } from './WatchersCount';

export class WatchersFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [WatchersCount];
  }

  get title() {
    return 'Watchers';
  }
}
